/*
  Keeps the "More in your size" rail in step with the size the shopper picks.

  Liquid has already filtered the first paint, so this file does nothing until
  the first click on a size. From then on it re-filters in place — no fetch, the
  whole brand pool is already in the DOM.

  Dawn replaces the variant picker's markup when a variant changes, so the
  listener is on the document rather than on the radios: a node bound directly
  would be thrown away by the first click it handled.
*/
(function () {
  var SKIP = 2; // below two matches, show the brand instead of a bare shelf

  function sizeFieldset(root) {
    var sets = root.querySelectorAll('fieldset');
    for (var i = 0; i < sets.length; i++) {
      var legend = sets[i].querySelector('legend');
      if (legend && legend.textContent.toLowerCase().indexOf('size') !== -1) return sets[i];
    }
    return null;
  }

  /* The picker is radios on this store, but a product with enough variants
     falls back to a <select>. Read whichever is present. */
  function selectedSize() {
    // The Shoes Egy product page (sections/shoes-egy-product.liquid).
    var own = document.querySelector('[data-pdp] [data-sizes] input:checked');
    if (own) return own.value.trim();
    var picker = document.querySelector('variant-selects');
    if (!picker) return '';
    var scope = sizeFieldset(picker) || picker;
    var checked = scope.querySelector('input[type="radio"]:checked');
    if (checked) return checked.value.trim();
    var select = scope.querySelector('select');
    return select ? select.value.trim() : '';
  }

  function apply(section) {
    var rail = section.querySelector('[data-more-rail]');
    var headingEl = section.querySelector('[data-more-heading]');
    if (!rail) return;

    var size = selectedSize();
    if (size === section.dataset.size) return; // nothing moved
    section.dataset.size = size;

    var items = rail.querySelectorAll('.shoes-more__item');
    var probe = '|' + size + '|';
    var matched = [];
    for (var i = 0; i < items.length; i++) {
      if (size && (items[i].dataset.sizes || '').indexOf(probe) !== -1) matched.push(items[i]);
    }

    var filtering = matched.length >= SKIP;
    var pool = filtering ? matched : Array.prototype.slice.call(items);
    var max = parseInt(section.dataset.showMax, 10) || 8;

    for (var j = 0; j < items.length; j++) items[j].hidden = true;
    for (var k = 0; k < pool.length && k < max; k++) pool[k].hidden = false;

    if (headingEl) {
      headingEl.textContent = filtering
        ? (section.dataset.headingSize || 'More in [size]').replace('[size]', size)
        : (section.dataset.headingBrand || 'More [brand]').replace('[brand]', section.dataset.brand || '');
    }
    var headingAr = section.querySelector('[data-more-heading-ar]');
    if (headingAr) {
      headingAr.textContent = filtering ? 'متاح في مقاسك ' + size : 'موديلات تانية من ' + (section.dataset.brand || '');
    }

    /* A rail scrolled halfway along then refilled would sit on whatever is now
       under the scroll position rather than at the start of the new set. */
    rail.scrollLeft = 0;
  }

  function refresh() {
    var sections = document.querySelectorAll('[data-more-in-size]');
    for (var i = 0; i < sections.length; i++) apply(sections[i]);
  }

  document.addEventListener('change', function (e) {
    if (e.target.closest && e.target.closest('variant-selects')) refresh();
  });
  // Sizes picked or restored by assets/shoes-egy-pdp.js.
  document.addEventListener('shoes:size-changed', refresh);

  /* Dawn also swaps the picker wholesale on some variant changes, which fires
     no change event of its own on the new node. A cheap observer covers it. */
  document.addEventListener('DOMContentLoaded', function () {
    var picker = document.querySelector('variant-selects');
    if (!picker || !window.MutationObserver) return;
    new MutationObserver(refresh).observe(picker, { childList: true, subtree: true });
  });
})();
